import React, { FC } from "react";
import { Routes } from "@Libs/Router/Components/Routes/Routes";
import { Route } from "@Libs/Router/Components/Route/Route";
import { Navigate } from "@Libs/Router/Components/Navigate/Navigate";
import { Match, On, Other } from "@Libs/Utils/Components/Match/Match";
import { useServiceProviderMetrics } from "@modules/ServiceProviders/hooks/useServiceProviderMetrics";
import { LoadingScreen } from "@UI/Components/LoadingScreen/LoadingScreen";
import { SuperTalent } from "@modules/ServiceProviders/Components/SuperTalent";
import { IAppRoute } from "@App/types";
import { RepeatRate } from "@modules/ServiceProviders/Components/RepeatRate";
import { useCurrentUser } from "@modules/Authentication/hooks/useCurrentUser";
import { RealisationRate } from "@modules/ServiceProviders/Components/RealisationRate";
import { useFeatureFlag } from "@Libs/FeatureFlags/hooks/useFeatureFlag";
import { useNavigate } from "@Libs/Router/hooks/useNavigate";
import { IErrorResponse } from "@api";

export const SERVICE_PROVIDER_METRICS_BASE_ROUTE: IAppRoute[] = [
  "SUPERTALENT_OBJECTIVES",
];

export const ServiceProviderMetricsRouter: FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useCurrentUser({
    includes: ["serviceProvider"],
  });

  const { isLoading, error } = useServiceProviderMetrics(
    currentUser?.serviceProvider?.id
  );

  const { feature: sp_behavior, isLoading: sp_behaviorLoading } =
    useFeatureFlag("sp_behavior");

  if (!sp_behavior?.enabled && !sp_behaviorLoading) {
    navigate("HOME", {
      reload: true,
    });
  }

  if (isLoading || sp_behaviorLoading) {
    return <LoadingScreen />;
  }

  return (
    <Match value={(error as IErrorResponse)?.response?.status}>
      <On valueBetween={[400, 499]}>
        <Navigate to="NOT_FOUND" reload />
      </On>

      <On valueBetween={[500, 599]}>
        <Navigate to="SERVER_ERROR" reload />
      </On>

      <Other>
        <Routes>
          <Route fragments="REPEAT_RATE" matchAny element={<RepeatRate />} />
          <Route
            fragments="REALISATION_RATE"
            matchAny
            element={<RealisationRate />}
          />
          <Route fragments="ROOT" matchAny element={<SuperTalent />} />
        </Routes>
      </Other>
    </Match>
  );
};
